const MIN_AVERAGE_SECONDS = 15;

const useHasSlowItemRate = (items: { created_at: string }[]): boolean => {
  return (() => {
    if (items.length < 2) return true;
    const first_item = items[0];
    const last_item = items[items.length - 1];
    const diff_seconds =
      (new Date(first_item.created_at).getTime() - new Date(last_item.created_at).getTime()) / 1000;
    const average_seconds = diff_seconds / (items.length - 1);
    return average_seconds >= MIN_AVERAGE_SECONDS;
  })();
};

export default useHasSlowItemRate;
